export class Card {
  constructor(
    last4,
    bankCode,
    cardType,
    cardNumber
  ) {
    this.last4 = last4;
    this.bankCode = bankCode;
    this.cardType = cardType;
    this.cardNumber = cardNumber;
  }

  static fromApiObject(input) {
    if (input && typeof (input) === "object") {
      return new Card(
        input.last4,
        input.bank_code,
        input.card_type,
        input.card_number
      )
    }

    return new Card();
  }

  static fromApiArray(input) {
    if (input && Array.isArray(input)) {
      return input.map(item => Card.fromApiObject(item));
    }

    if (input && typeof (input) === "object") {
      return [Card.fromApiObject(input)];
    }

    return [];
  }
}